import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CUSTOMIZATION_REQUEST_ASYNC,
  LANGUAGE_CHANGE,
  UPDATE_CUSTOMIZATION_REQUEST,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case CUSTOMIZATION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case CUSTOMIZATION_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case CUSTOMIZATION_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CUSTOMIZATION_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_CUSTOMIZATION_REQUEST.INITIATE:
        return {
          ...state,
          data: action.payload.data,
          loader: true,
        }
      case UPDATE_CUSTOMIZATION_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_CUSTOMIZATION_REQUEST.CANCEL:
        return { ...state, loader: false }
      case LANGUAGE_CHANGE:
        return {
          ...state,
          data: {
            ...state.data,
            locale: action.payload.language,
          },
        }
      default:
        return state
    }
  }
}
